import { render } from "./PerfilAdmin.vue?vue&type=template&id=667b02a5&scoped=true"
import script from "./PerfilAdmin.vue?vue&type=script&lang=js"
export * from "./PerfilAdmin.vue?vue&type=script&lang=js"

import "./PerfilAdmin.vue?vue&type=style&index=0&id=667b02a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667b02a5"]])

export default __exports__